import classNames from "classnames";
import { ButtonGroupProps } from "./types";

/**
 * Wrapper component for displaying multiple button
 */
export default function ButtonGroup(props: ButtonGroupProps) {
  return (
    <div
      data-testid={props.testId}
      className={classNames("ptButtonGroup", props.className, {
        ptButtonGroup_inlineFormButtons: props.inlineFormButtons,
        ptButtonGroup_fullWidth: props.fullWidth,
        ptButtonGroup_floating: props.isFloating,
        ptButtonGroup_shadow: props.hasShadow
      })}>
      {props.children}
    </div>
  );
}
